import { render, staticRenderFns } from "./UsersCheckersQueueTable.vue?vue&type=template&id=153dbb3e&scoped=true&"
import script from "./UsersCheckersQueueTable.vue?vue&type=script&lang=js&"
export * from "./UsersCheckersQueueTable.vue?vue&type=script&lang=js&"
import style0 from "./UsersCheckersQueueTable.vue?vue&type=style&index=0&id=153dbb3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153dbb3e",
  null
  
)

export default component.exports